/*!
 Enable mouse scroll wheel scroll on the map.
 (c) 2014-2018 Andxor soluzioni informatiche <http://www.andxor.it/>
*/

import { Map } from 'leaflet/src/map/Map';
import * as DomEvent from 'leaflet/src/dom/DomEvent';
import { Handler } from 'leaflet/src/core/Handler';

Map.mergeOptions({
    scrollWheelZoom: false,
    scrollWheelScroll: true,
    scrollWheelSpeed: 6
});

export var ScrollWheelScroll = Handler.extend({
    addHooks: function () {
        DomEvent.on(this._map._container, 'mousewheel', this._onWheelScroll, this);
        DomEvent.on(this._map._container, 'MozMousePixelScroll', DomEvent.preventDefault);
    },

    removeHooks: function () {
        DomEvent.off(this._map._container, 'mousewheel', this._onWheelScroll);
        DomEvent.off(this._map._container, 'MozMousePixelScroll', DomEvent.preventDefault);
    },

    _onWheelScroll: function (e) {
        if (this._map._panAnim && this._map._panAnim._inProgress)
            return;

        var delta = DomEvent.getWheelDelta(e);

        this._map.panBy([ 0, -delta * this._map.options.scrollWheelSpeed ]);

        DomEvent.preventDefault(e);
        DomEvent.stopPropagation(e);
    }
});

Map.addInitHook('addHandler', 'scrollWheelScroll', ScrollWheelScroll);
